import { SvgIcon } from "@mui/material";

const RadioIconBold = ({ ...props }) => (
    <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2.5" y="2.5" width="15" height="15" rx="9.5" stroke="#7AA6A3" strokeWidth="4" fill="white" />
    </SvgIcon>
)

export default RadioIconBold;